import { ICar, IGalleryImageObject, IGarage } from 'shared-interfaces'
import { landrover } from '@/public/assets/landrover'

export const images_data: IGalleryImageObject = {}
let images_ids_list: string[] = []

landrover.forEach((item, i) => {
    images_data[`img${i}`] = {
        id: `img${i}`,
        caption: `2016 Land Rover Defender 90 Heritage ${i}`,
        credits: 'Jeremy Hindle',
        location: 'London',
        image_url: item.src,
    }
    images_ids_list.push(`img${i}`)
})

export const mock_car: ICar = {
    id: 'carid',
    // OVERVIEW
    owner: {
        fullname: 'Jeremy Hindle',
        profile_image_url: '',
        location: 'London, United Kingdom',
        id: 'id',
    },
    title: '2016 Land Rover Defender 90 Heritage',
    short_description:
        'One of only 400 Heritage Editions produced to mark the end of the original Defender production. Looks great in the traditional Grasmere Green with the HUE 166 badging.',
    banner: { id: 'mock_banner', image_url: landrover[0].src },
    cover_image_id: images_ids_list[1],
    overview_images_ids: [
        images_ids_list[2],
        images_ids_list[3],
        images_ids_list[4],
        images_ids_list[5],
        images_ids_list[6],
        images_ids_list[7],
    ],
    highlighted_facts: [
        'This is one of only 400 Heritage Editions produced in both long and short wheelbase form to mark the ending of original Defender production.',
        'Finished in the traditional Land Rover colour of Grasmere Green',
        'Features many nods to models past including the Almond cloth upholstery, painted steel wheels and HUE 166 badging, this being the registration number of the first Land Rover prototype.',
        'Only done 5,000 miles since new and always carefully stored inside.',
        'Always correctly serviced by a Land Rover main dealer.',
    ],
    description: `<p>This is one of only 400 Heritage Editions produced in both long and short wheelbase form to mark the ending of original Defender production. Finished in the traditional Land Rover colour of Grasmere Green, the model features many nods to models past including the Almond cloth upholstery, painted steel wheels and HUE 166 badging, this being the registration number of the first Land Rover prototype.</p><p><br></p><p>The Heritage was hugely in demand from its announcement in 2015 and this has increased over time. Hence, immaculate low mileage examples, of especially the short wheelbase model, are rarely available.&nbsp;</p><p><br></p><p>Here we have just such a car, one of the last Heritage models to be registered. I purchased the car from its first owner when it was still brand new and sold it days later to the second owner from whom I have recently repurchased it. It has covered 5,000 gentle road miles and has been very carefully stored with the previous owner’s other immaculate cars when not in use. Hence, it remains unmarked and as new throughout without the detail deterioration one sees in many other examples that have been left outside. It has been correctly serviced by a Land Rover main dealer and comes with all keys, books, invoices and the unique book supplied with each new Heritage Edition model.</p>`,
    // GALLERY
    galleryData: images_data,
    galleryIdsList: images_ids_list,
    // TECH INFO
    make: 'Land Rover',
    model: 'Defender',
    year: '2016',
    body_type: 'SUV / 4x4',
    drive_side: 'RHD',
    transmission: 'Manual',
    mileage: '500 mi',
    engine_capacity: '2198 cc',
    registration_number: 'SO65 CVD',
    registration_date: '2016-01-01',
    service_check_status: 'valid',
    last_owner_change: '2006-02-22',
    service_check_expiry: '2022-05-11',
    tax_status: 'SORN',
    tax_due: '',
    color_exterior: 'green',
    color_interior: 'black',
    fuel_type: 'Diesel',
    drive_train: '-',
}

export const mock_car2: ICar = {
    id: 'carid',
    // OVERVIEW
    owner: {
        fullname: 'Jeremy Hindle',
        profile_image_url: null,
        location: null,
        id: 'id',
    },
    title: '2016 Land Rover Defender 90 Heritage',
    short_description: null,
    banner: null,
    cover_image_id: null,
    overview_images_ids: null,
    highlighted_facts: null,
    description: null,
    // GALLERY
    galleryData: null,
    galleryIdsList: null,
    // TECH INFO
    make: 'Land Rover',
    model: 'Defender',
    year: null,
    body_type: null,
    drive_side: null,
    transmission: null,
    mileage: null,
    engine_capacity: null,
    registration_number: null,
    registration_date: null,
    service_check_status: null,
    last_owner_change: null,
    service_check_expiry: null,
    tax_status: null,
    tax_due: null,
    color_exterior: null,
    color_interior: null,
    fuel_type: null,
    drive_train: null,
}

export const mock_garage: IGarage = {
    id: 'garageid',
    owner: {
        fullname: 'Jeremy Hindle',
        profile_image_url: '',
        location: 'London, United Kingdom',
        id: 'id',
        bio: 'In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before the final copy is available.',
    },
    carIdsList: ['carid', 'carid2'],
    carsData: {
        carid: mock_car,
        carid2: mock_car2,
    },
}
